import { keyframes } from "@mui/material";
import { createPortal } from "react-dom";

import { TooltipPos } from "./useDelayedTooltip";

const tooltipIn = keyframes`
    from { opacity: 0; transform: translate(-50%, calc(-100% + 4px)); }
    to   { opacity: 1; transform: translate(-50%, -100%); }
`;

const TOOLTIP_STYLE = {
    position: "fixed" as const,
    backgroundColor: "#1a2026",
    color: "#ffffff",
    fontSize: 12,
    lineHeight: "16px",
    letterSpacing: "0.25px",
    fontFamily: "Inter, sans-serif",
    borderRadius: 6,
    padding: "4px 8px",
    boxShadow: "0 10px 15px -3px rgba(0,0,0,0.15), 0 4px 6px -4px rgba(0,0,0,0.1)",
    zIndex: 99999,
    pointerEvents: "none" as const,
};

export function DelayedTooltip({ pos, maxWidth }: { pos: TooltipPos | null; maxWidth?: number }) {
    if (!pos) {
        return null;
    }
    return createPortal(
        <div
            style={{
                ...TOOLTIP_STYLE,
                left: pos.x,
                top: pos.y,
                transform: "translate(-50%, -100%)",
                animation: `${tooltipIn} 0.15s ease-out both`,
                ...(maxWidth != null ? { maxWidth, overflowWrap: "break-word" as const } : { whiteSpace: "nowrap" }),
            }}
        >
            {pos.text}
        </div>,
        document.body,
    );
}
